import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import RecipeForm from "@/components/RecipeForm";

export default function EditRecipe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get(`/recipes/${id}`).then((r) => setRecipe(r.data)); }, [id]);

  const save = async (payload) => {
    setSaving(true);
    try {
      payload.images = recipe.images || [];
      payload.source = recipe.source;
      payload.is_favorite = recipe.is_favorite;
      await api.put(`/recipes/${id}`, payload);
      toast.success("Recette mise à jour");
      navigate(`/recipes/${id}`);
    } catch {
      toast.error("Erreur lors de la mise à jour");
    } finally {
      setSaving(false);
    }
  };

  if (!recipe) return <div className="px-5 pt-10 text-center" style={{ color: "var(--at-muted)" }}>Chargement...</div>;

  return (
    <div className="px-5 pt-8" data-testid="edit-recipe-page">
      <button onClick={() => navigate(-1)} className="mb-3 flex items-center gap-1 text-sm font-medium at-press" style={{ color: "var(--at-text-2)" }}>
        <ArrowLeft size={16} /> Retour
      </button>
      <h1 className="mb-5 font-display text-2xl font-bold">Modifier la recette</h1>
      <RecipeForm initial={recipe} onSave={save} saving={saving} submitLabel="Enregistrer les modifications" />
    </div>
  );
}
